import { render, staticRenderFns } from "./DepartmentDetails.vue?vue&type=template&id=4820756e&scoped=true"
import script from "./DepartmentDetails.vue?vue&type=script&lang=js"
export * from "./DepartmentDetails.vue?vue&type=script&lang=js"
import style0 from "./DepartmentDetails.vue?vue&type=style&index=0&id=4820756e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.30_css-loader@6.11.0_webpack@5.105.4__lodash@4.17.23_webpack@5.105.4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4820756e",
  null
  
)

export default component.exports